<template>
      <innerPage v-if="innerPages.includes(this.$route.meta.title)" />
      <outerPage v-else />
</template>

<script>
import innerPage from './components/innerPage'
import outerPage from './components/outerPage'
export default {
  name: 'App',
  components: {
    innerPage,
    outerPage
  },
  data: () => ({
    innerPages:['News','Dashboard','Live','Summary','Transactions','Indicators','Graph','Mempool','Screener','Score'],
    outerPages:['Login','Page not found']
  }),
  methods:{

  },
};
</script>
<style lang="scss">
@import 'vue-select/src/scss/vue-select.scss';
@import './assets/styles/fonts.css';
@import './assets/styles/themes.css';
@import './assets/styles/common.scss';
*{
  box-sizing: border-box;
  outline: 0 !important;
}
html,body{
  margin: 0px;
  font-family: 'Poppins',sans-serif;
  min-width: 320px;
}
h1, h2, h3, h4, h5, h6 {
    margin: 10px 0;
    color: var(--font-color);
    font-weight: 600;
}
h3 {
    font-size: 26px;
    line-height: 39px;
}
#wrapper{
  overflow-x: hidden;
  min-height: 100vh;
  background: var(--main-bg-color);
  color: var(--font-color);
}
</style>